import BaseService from './base.service'
import baseApi from './base.api'
import { toast } from '@/common/util'
import type { InscreverUsuarios } from '@/types/types'

export const courseService = {
  ...baseApi,
  resource: 'curso',
  async getSubscriptions(opt: {
    id: string
    status: boolean
    active?: boolean
    name?: string
    search?: string
    positionIds?: string[]
    departmentsIds?: string[]
    unitIds?: string[]
    origin?: null | 'manual' | 'manager' | 'auto-position' | 'auto-unit' | 'import' | 'external-page'
    page?: number
    size?: number
    orderBy?: { prop: string, order: 'ASC' | 'DESC' }[]
    // order?: null | 'name' | 'department' | 'position' | 'unit' | 'origin'
    // direction?: null | 'asc' | 'desc'
  }, options?: any) {
    if (!opt.id) throw new Error('Id do curso não informado!')
    if (typeof opt.status === 'undefined') throw new Error('Tipo não informado!')

    const paramsDictionary = {
      active: 'ativo',
      name: 'nomeCompleto',
      search: 'search',
      positionIds: 'CargoIds',
      departmentsIds: 'departamentoIds',
      unitIds: 'unidadeDeNegocioIds',
      origin: 'origem',
      page: 'page',
      size: 'size'
    }

    const originDictionary = {
      manual: 'Manual',
      manager: 'Gestor',
      'auto-position': 'AutoCargo',
      'auto-unit': 'AutoUnidade',
      import: 'Importacao',
      'external-page': 'PaginaExterna'
    }

    const orderDictionary = {
      name: 'Usuario',
      department: 'Departamento',
      position: 'Cargo',
      unit: 'Unidade',
      origin: 'Origem',
      progress: 'Progresso',
      email: 'Email'
    }

    const extraData = {}

    Object.keys(opt).forEach((key) => {
      if (typeof paramsDictionary[key] !== 'undefined' && typeof opt[key] !== 'undefined' && opt[key] !== null)
        extraData[paramsDictionary[key]] = opt[key]

      if (key === 'origin' && extraData[paramsDictionary[key]]) {
        extraData[paramsDictionary[key]] = originDictionary[extraData[paramsDictionary[key]]]
      }
    })

    // Ordenação
    if (opt.orderBy?.length) {
      extraData['Ordenacao'] = opt.orderBy.map((item) => `${orderDictionary[item.prop]}${item.order === 'DESC' ? 'Desc' : 'Asc'}`)
    }

    // if (opt.order && orderDictionary[opt.order]) {
    //   extraData['Ordenacao'] = orderDictionary[opt.order] + (opt.direction === 'desc' ? 'Desc' : 'Asc')
    // }

    return courseService
      .get<any>(`Usuarios/${opt.status}/${opt.id}`, extraData,  options)
      .then((res) => ({
        status: res.success,
        page: res.pageNumber,
        size: res.pageSize,
        total: res.totalItems,
        pages: res.totalPages,
        data: res.data?.map((item) => ({
          id: item.id || null,
          userId: item.usuarioId,
          name: item.nome,
          active: item.active,
          progress: item.percentualConsumoConteudo || 0,
          unit: item.unidade,
          department: item.departamento,
          position: item.cargo,
          origin: item.origem,
          email: item.email
        })) as {
          id: string | null
          userId: string
          name: string
          progress: number
          active: boolean
          unit: string | null
          department: string | null
          position: string | null
          origin: string | null
          email: string
        }[]
      }))
  },
  /**
   * Inscreve o usuário em um curso
   * @param id - id do curso
   * @param journeyId - opcional, para cursos que fazem parte de uma jornada
   */
  enroll(id: string, journeyId?: string) {
    return courseService.post([id, 'subscribe'].join('/'), {
      jornadaId: journeyId || null
    })
  },
  /**
   * Inscreve o usuário em um curso
   * @param id
   */
  unenroll(id: string) {
    return courseService.post([id, 'unsubscribe'].join('/'))
  },

  async getCourses(opt?: {
    id?: string
    active?: boolean
    title?: string
    search?: string
    categoryId?: string
    courseIds?: string[]
    code?: string
    competenceIds?: string[]

  }, options?: any) {
    const paramsDictionary = {
      id: 'id',
      active: 'ativo',
      title: 'titulo',
      search: 'search',
      categoryId: 'categoriaId',
      courseIds: 'cursoIds',
      code: 'codigoCurso',
      competenceIds: 'competenciasIds',
    }

    const paramsToSend = {}

    if (opt) {
      Object.keys(opt).forEach((key) => {
        if (typeof paramsDictionary[key] !== 'undefined' && typeof opt[key] !== 'undefined' && opt[key] !== null)
          paramsToSend[paramsDictionary[key]] = opt[key]
      })
    }

    return courseService.get<any>('', paramsToSend, options)
    .then((res) => ({
      status: res.success,
      data: res.data?.map((item) => ({
        id: item.id || null,
        titulo: item.titulo,
        active: item.active,
        origem: item.origem,
        synopsis: item.sinopse,
        description: item.descricao,
        cargaHoraria: item.cargaHoraria,
        categoriaId: item.categoriaId,
        certificadoId: item.certificadoId,
        categoriaNome: item.categoriaNome,
        obrigatorio: item.obrigatorio,
        sequenciaObrigatoria: item.sequenciaObrigatoria,
        limiteDeDiasParaConclusao: item.limiteDeDiasParaConclusao,
        aproveitamentoRequerido: item.aproveitamentoRequerido,
        temMaterialComplementar: item.temMaterialComplementar,
        competenciasIds: item.competenciasIds,
        secoesIds: item.secoesIds,
        itens: item.itens,
        itensDoCurso: item.itensDoCurso,
        linkDaImagemDeCapa: item.linkDaImagemDeCapa,
        contadores: item.contadores,
        createdAt: item.createdAt,
        inscrito: item.inscrito,
        ativo: item.ativo,
        finalizado: item.finalizado,
        porcentagemDeConclusao: item.porcentagemDeConclusao,
        expirado: item.expirado,
        codigoCurso: item.codigoCurso,
        inscricoes: item.inscricoes,
        dataExpirada: item.dataExpirada,
        desafiosIds: item.desafiosIds,
        possuiAnotacao: item.possuiAnotacao,
        cursoOrigemId: item.cursoOrigemId,
      })),
    }))
  },

  bookmark(courseId: string, remove?: boolean) {
    return courseService.post([courseId, !remove ? 'bookmark' : 'unbookmark'].join('/'))
  },

  unbookmark(courseId: string) {
    return courseService.post([courseId, 'unbookmark'].join('/'))
  },

  setReactionCourse(params: { id: string, reacao?: string }) {
    return courseService.post(`SetReaction`, params)
  },

  getDetails(courseId: string, ignoreFilterSection: boolean = false) {
    return courseService.get(`Detalhes/${courseId}`, {
      params: { ignoreFilterSection }
    })
  },

  coverUpload(id: string, file, orientation: 'horizontal' | 'vertical') {
    const type = orientation === 'horizontal' ? 'CardHorizontal' : 'CardVertical'

    const formData = new FormData()
    formData.append('arquivo', file)

    return courseService.post(`${id}/fileUpload/${type}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

class CursosService extends BaseService {
  constructor() {
    super({ resource: 'curso' })
  }

  /**
   * Inscreve o usuário em um curso
   * @param courseId
   */

  async fileUpload(id: string, file) {
    const formData = new FormData()

    formData.append('arquivo', file)
    formData.append('cursoId', id)

    return await this.plantarApi.post(`${this.resource}/${id}/fileUpload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  async getBonds(cursoId: string) {
    return this.plantarApi.get(`${this.resource}/vinculos/${cursoId}`)
  }

  async sendSubscriptions(data: InscreverUsuarios, inscrever?: boolean) {
    return this.plantarApi.post(`${this.resource}/inscreverusuarios/${inscrever}`, data)
  }

  async getDetails(courseId: string, ignoreFilterSection: boolean = false) {
    try {
      return this.plantarApi.get(`${this.resource}/Detalhes/${courseId}`, {
        params: { ignoreFilterSection }
      })

    } catch (error) {
      const { notifications }: { notifications: string[] } = error.response?.data || {}
      toast.error({message: notifications[0]})
    }
  }
}

const cursosService = new CursosService()

export default cursosService
